import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class RiderScheduleTrainingCenterService {
    constructor(private apiHttp: ApiHttp) {
    }

    public updateScheduleTrainingStatus(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressRiderScheduleTrainingCenter/UpdateScheduleTrainingStatus', data, messageService);
    }
}
